import type React from "react";
import { useEffect } from "react";

import { GoogleLoginConfigError, GoogleScriptLoadError } from "../types/errors";

import { LoginErrorBoundary } from "./LoginErrorBoundary";

interface LoginWithGoogleProps {
  className?: string;
}

export const LoginWithGoogle: React.FC<LoginWithGoogleProps> = ({
  className,
}) => {
  const clientId = import.meta.env.VITE_GOOGLE_LOGIN_CLIENT_ID;
  const backendEndpoint = import.meta.env.VITE_GOOGLE_LOGIN_REDIRECT_URI;

  if (!clientId) {
    throw new GoogleLoginConfigError("Google client ID is not configured");
  }
  if (!backendEndpoint) {
    throw new GoogleLoginConfigError(
      "Google login redirect URI is not configured",
    );
  }

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.id = "google-login-script";

    script.onerror = () => {
      throw new GoogleScriptLoadError();
    };

    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <LoginErrorBoundary onRetry={handleRetry}>
      <div className={className}>
        <div
          id="g_id_onload"
          data-client_id={clientId}
          data-context="signin"
          data-ux_mode="popup"
          data-auto_prompt="false"
          data-login_uri={backendEndpoint}
        />
        <div
          className="g_id_signin"
          data-type="standard"
          data-shape="rectangular"
          data-theme="outline"
          data-text="signin_with"
          data-size="large"
          data-logo_alignment="left"
        />
      </div>
    </LoginErrorBoundary>
  );
};
